module.exports = "../content/31be5dfb018c62ea49f3a27195727c12.woff2";